import React from "react";
import { EndCustomerComment } from "@api/graphql/generated/generated-types";
import { CommentItem } from "./CommentItem";

interface Props {
  comments: EndCustomerComment[];
}

export function CommentList({ comments }: Props) {
  if (comments.length === 0) return null;
  return (
    <div className="flex flex-col gap-3">
      {comments.map((comment) => (
        <CommentItem key={comment.id} createdBy={comment.createdBy} createdAt={comment.createdAt} text={comment.text} />
      ))}
    </div>
  );
}
